import React from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ModalMapaSelecao.css';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

const MAPA_SELECIONADO_KEY = 'mapa_selecionado_codigo_familia';

const mapOptions = [
  { value: '11426', label: '11426 - SETPARQUE WORKFIRE II' },
  { value: '11455', label: '11455 - SETJARDIM TANABI' },
  { value: '11419', label: '11419 - SETJARDIM CAÇAPAVA' },
  { value: '11453', label: '11453 - SETVALLEY HORIZONTE  2 (SJC)' },
  { value: '11453', label: '11453 - SETVALLEY HORIZONTE  1 (SJC)' },
];

const ModalMapaSelecao = ({ show, onHide, onSelect }) => {
  const handleChange = option => {
    if (!option) return;
    localStorage.setItem(MAPA_SELECIONADO_KEY, option.value);
    onSelect(option.value);
  };

  const handleClose = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={true}
      className="modal-selecao-mapa"
    >
      <Modal.Header closeButton>
        <Modal.Title>Mapas Disponíveis</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div>
          <label className="mb-1">Empreendimento</label>
          <Select
            isSearchable
            options={mapOptions}
            value={null}
            onChange={handleChange}
            placeholder="Selecione um empreendimento"
            noOptionsMessage={() => 'Nenhum empreendimento encontrado'}
            styles={customStyles}
            components={{ DropdownIndicator }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export { MAPA_SELECIONADO_KEY };
export default ModalMapaSelecao;